// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import {Loading,Pagination} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import BaiduMap from 'vue-baidu-map'


Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'DIdnF87ExnXZ9CtaNBjuX96UzmEuaDhe'
})

import './main.css'

axios.defaults.baseURL='https://www.eaia.cn/api/'    //正式环境修改地址时注意修改pdf的访问地址
// axios.defaults.baseURL='/api/'    //正式环境修改地址时注意修改pdf的访问地址


Vue.use(Loading);
Vue.use(Pagination);
Vue.prototype.axios=axios;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js